/* Liberty Club — subtle ambient engine: journey bar + faint star sprinkles on dark sections only. */
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Gold scroll-progress (journey) bar */
  var bar = document.createElement('div');
  bar.className = 'lc-progress';
  document.body.appendChild(bar);
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () {
      var d = document.documentElement;
      var max = d.scrollHeight - d.clientHeight;
      bar.style.width = (max > 0 ? (d.scrollTop / max) * 100 : 0) + '%';
      ticking = false;
    });
  }, { passive: true });

  if (reduced) return;

  /* A FEW faint stars, only on the deep navy moments (VIP + footer). */
  [['.lc-vip__wrap', 9], ['.footer', 11]].forEach(function (pair) {
    var host = document.querySelector(pair[0]);
    if (!host) return;
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    var wrap = document.createElement('div');
    wrap.className = 'lc-stars';
    wrap.setAttribute('aria-hidden', 'true');
    for (var i = 0; i < pair[1]; i++) {
      var s = document.createElement('i');
      s.style.left = (Math.random() * 100) + '%';
      s.style.top = (Math.random() * 100) + '%';
      s.style.animationDelay = (Math.random() * 6) + 's';
      wrap.appendChild(s);
    }
    host.insertBefore(wrap, host.firstChild);
  });
})();
